var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import cn from "classnames";
import { bem } from "@react-md/utils";
var block = bem("rmd-card");
/**
 * A subtitle for the `Card`. This is usually used with the `CardHeader`
 * component after the `CardTitle`.
 */
var CardSubtitle = forwardRef(function CardSubtitle(_a, ref) {
    var className = _a.className, children = _a.children, _b = _a.noWrap, noWrap = _b === void 0 ? false : _b, _c = _a.disableSecondaryColor, disableSecondaryColor = _c === void 0 ? false : _c, props = __rest(_a, ["className", "children", "noWrap", "disableSecondaryColor"]);
    return (React.createElement("h6", __assign({}, props, { ref: ref, className: cn(block("subtitle", {
            secondary: !disableSecondaryColor,
        }), {
            "rmd-card--no-wrap": noWrap,
        }, className) }), children));
});
if (process.env.NODE_ENV !== "production") {
    try {
        var PropTypes = require("prop-types");
        CardSubtitle.propTypes = {
            className: PropTypes.string,
            noWrap: PropTypes.bool,
            disableSecondaryColor: PropTypes.bool,
            children: PropTypes.node,
        };
    }
    catch (e) { }
}
export default CardSubtitle;
//# sourceMappingURL=CardSubtitle.js.map